import {CSSProperties} from '../../../styleSheet';
import {BaseBorderPxProps} from '../types';

export const buildBorderStyle = ({
  borderBottomColor,
  borderBottomLeftRadius,
  borderBottomRadius,
  borderBottomRightRadius,
  borderBottomWidth,
  borderColor,
  borderLeftColor,
  borderLeftRadius,
  borderLeftWidth,
  borderRadius,
  borderRightColor,
  borderRightRadius,
  borderRightWidth,
  borderStyle,
  borderTopColor,
  borderTopLeftRadius,
  borderTopRadius,
  borderTopRightRadius,
  borderTopWidth,
  borderWidth,
  borderTopStyle,
  borderLeftStyle,
  borderRightStyle,
  borderBottomStyle,
  borderPosition,
}: BaseBorderPxProps = {}): CSSProperties => {
  return {
    ...(borderColor ? {borderColor: borderColor} : {}),
    ...(borderStyle ? {borderStyle: borderStyle} : {}),
    ...(borderRadius ? {borderRadius: `${borderRadius}px`} : {}),
    ...(borderWidth ? {borderWidth: `${borderWidth}px`} : {}),
    ...(borderBottomColor ? {borderBottomColor: borderBottomColor} : {}),
    ...(borderBottomRadius
      ? {borderBottomRadius: `${borderBottomRadius}px`}
      : {}),
    ...(borderBottomWidth ? {borderBottomWidth: `${borderBottomWidth}px`} : {}),
    ...(borderLeftColor ? {borderLeftColor: borderLeftColor} : {}),
    ...(borderLeftRadius ? {borderLeftRadius: `${borderLeftRadius}px`} : {}),
    ...(borderLeftWidth ? {borderLeftWidth: `${borderLeftWidth}px`} : {}),
    ...(borderRightColor ? {borderRightColor: borderRightColor} : {}),
    ...(borderRightRadius ? {borderRightRadius: `${borderRightRadius}px`} : {}),
    ...(borderRightWidth ? {borderRightWidth: `${borderRightWidth}px`} : {}),
    ...(borderTopColor ? {borderTopColor: borderTopColor} : {}),
    ...(borderTopRadius ? {borderTopRadius: `${borderTopRadius}px`} : {}),
    ...(borderTopWidth ? {borderTopWidth: `${borderTopWidth}px`} : {}),
    ...(borderBottomLeftRadius
      ? {borderBottomLeftRadius: `${borderBottomLeftRadius}px`}
      : {}),
    ...(borderBottomRightRadius
      ? {borderBottomRightRadius: `${borderBottomRightRadius}px`}
      : {}),
    ...(borderTopLeftRadius
      ? {borderTopLeftRadius: `${borderTopLeftRadius}px`}
      : {}),
    ...(borderTopRightRadius
      ? {borderTopRightRadius: `${borderTopRightRadius}px`}
      : {}),
    ...(borderLeftStyle ? {borderLeftStyle} : {}),
    ...(borderRightStyle ? {borderRightStyle} : {}),
    ...(borderTopStyle ? {borderTopStyle} : {}),
    ...(borderBottomStyle ? {borderBottomStyle} : {}),
    ...(borderPosition === 'inside'
      ? {
          'box-sizing': 'border-box',
          '-moz-box-sizing': 'border-box',
          '-webkit-box-sizing': 'border-box',
        }
      : {}),
  };
};
